import React from "react";
import "@google/model-viewer/dist/model-viewer";
import { Spin } from "antd";
import { LoadingPage } from "../images";

interface IProductModelProps {
  src: string;
  poster: string;
  product_name: string;
}

const ProductModel = ({ src, poster, product_name }: IProductModelProps) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const modelViewer: any = document.getElementsByTagName("model-viewer");
  let interval: any;

  React.useEffect(() => {
    interval = setInterval(() => {
      if (modelViewer && modelViewer.length && modelViewer[0].loaded) {
        setIsLoading(false);
        clearInterval(interval);
      }
    }, 500);
  }, []);

  return (
    <div className="product-model-viewer-wrapper">
      {isLoading ? (
        <div className="mask-3D-loading">
          <Spin
            indicator={
              <img src={LoadingPage} style={{ height: 80, width: "auto" }} />
            }
          />
        </div>
      ) : null}
      <model-viewer
        class="product-model-viewer image-gallery-image"
        loading="auto"
        camera-controls
        auto-rotate
        shadow-intensity="1"
        ar
        ar-scale="fixed"
        src={src}
        poster={poster}
        // shadow-intensity='1'
        // ar
        // ar-scale='fixed'
        alt={product_name}
      />
    </div>
  );
};

export default ProductModel;
